export default __webpack_public_path__ + "static/media/hsg_logo_white.bad665e3.png";